export default __webpack_public_path__ + "static/media/yapily-connect.968e428c.svg";